/**
 * @description 商品投保作業頁面切換用
*/
export enum InsProcessStep {
  /** 我要試算 */
  InsureProcessCalc = 1,
  /** 填寫資料 Page 1 */
  InsureProcessFill1st = 2,
  /** 填寫資料 Page 2 */
  InsureProcessFill2nd = 3,
  /** 資料預覽 */
  InsureProcessPreview = 4,
  /** 驗證 OTP 驗證碼 */
  InsureProcessVerifyOTP = 5,
  /** 確認付款 */
  InsureProcessPayment = 6,
  /** 成功投保 */
  InsureProcessSuccess = 7
}
